import React, { useContext } from "react";
import { FaCheckDouble, FaBuilding, FaHardHat, FaShieldAlt } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import '../Audit/AuditGlobal.css';
import BannerImage from '../../assets/core_services/structural_stability_hero_1776820049060.png';

function StructuralStability() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/structural-stability');
    } else {
      navigate('/login', { state: { from: '/booking/structural-stability' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Core Services</span>
          <h1 className="hero-title">Structural Stability Certificate</h1>
          <p className="hero-subtitle">
            Ensuring the safety, reliability, and compliance of your building structures.
            Expert assessments for long-term structural integrity.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Enquire Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Why Structural Stability Matters?</h2>
              <p className="article-text">
                The safety of an industrial or commercial building is paramount. A Structural Stability Certificate ensures that your infrastructure can safely bear the dynamic and static loads over its intended lifecycle, safeguarding both human lives and capital investments.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Our Assessment Process</h2>
              <p className="article-text">
                Our certified structural engineers perform comprehensive evaluations encompassing:
                <br />- <strong>Visual Inspection:</strong> Detecting visible signs of wear, cracks, and concrete spalling.
                <br />- <strong>Load Testing:</strong> Verifying the structure's capacity to withstand operational demands.
                <br />- <strong>Material Analysis:</strong> Using advanced techniques to determine the strength of construction materials.
                <br />- <strong>Compliance Checking:</strong> Ensuring the building adheres to national and local building codes.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The Benefits</h2>
              <p className="article-text">
                Securing a Structural Stability Certificate provides legal compliance, reduces the risk of catastrophic failures, and enhances the overall value and insurability of the property.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Key Pillars</h4>
              <ul className="key-list">
                <li><FaBuilding className="check-icon" /> Building Integrity</li>
                <li><FaHardHat className="check-icon" /> Operational Safety</li>
                <li><FaCheckDouble className="check-icon" /> Code Compliance</li>
                <li><FaShieldAlt className="check-icon" /> Risk Mitigation</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Get Certified Today</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Ensure your structures are safe and compliant.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Schedule Assessment
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default StructuralStability;
